import * as React from 'react'
import { logsIframeEvents } from '../../../segment/actions'
import { Profile } from '../../../remote-api/CoreServicesRemoteApi'
import { MessageStrategy } from '@mulesoft/monitoring-center-components/lib/components/Iframe/Iframe'
import { IframeLoading } from '@mulesoft/monitoring-center-components/lib/components/Iframe/IframeLoading'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Iframe/IframeLoadingState'
import { DataMessageEventHandler } from '@mulesoft/monitoring-center-components/lib/components/Iframe/event/message/custom/DataMessageEventHandler'
import { ErrorMessageEventHandler } from '@mulesoft/monitoring-center-components/lib/components/Iframe/event/message/custom/ErrorMessageEventHandler'
import IframeContainer from '../../Iframe/IframeContainer'
import visualizerApi from '../../../util/VisualizerApi'

import AlertErrorEventHandler
  from '@mulesoft/monitoring-center-components/lib/components/Iframe/event/AlertErrorEventHandler'

export type ValueProps = {
  profile?: Profile
}

export type EventProps = {
  notifyEvent: (type: string, event: string, detail?: any) => void
  notifyError: (error: any) => void
}

export type Props = ValueProps & EventProps

export default class LogSearchIframe extends React.Component<Props> {

  private readonly id = 'logs-iframe'
  private readonly src = '/monitoring/api/logs/app/kibana'
  private readonly displayedStrategy: MessageStrategy = {type: 'message'}

  private profileHandler?: DataMessageEventHandler<Profile> = undefined

  private readonly alertErrorHandler: AlertErrorEventHandler
  private readonly errorHandler: ErrorMessageEventHandler<{ message: any, errorCode: any }>

  constructor(props: Props) {
    super(props)

    this.errorHandler = new ErrorMessageEventHandler(this.props.notifyError)
    this.alertErrorHandler = new AlertErrorEventHandler(this.props.notifyError)

    this.onIframeStateChange = this.onIframeStateChange.bind(this)
  }

  render() {
    if (this.props.profile === undefined) {
      return <IframeLoading/>
    }

    if (this.profileHandler === undefined) {
      this.profileHandler = new DataMessageEventHandler('profile', this.props.profile)
    }

    const staticEventHandlers = [this.alertErrorHandler, this.errorHandler, this.profileHandler]

    return (
      <IframeContainer
        id={this.id}
        src={this.src}
        eventHandlers={staticEventHandlers}
        onIframeStateChange={this.onIframeStateChange}
        displayedStrategy={this.displayedStrategy}
      />
    )
  }

  private onIframeStateChange(state: IframeLoadingState) {
    if (state === IframeLoadingState.LOADED) {
      logsIframeEvents.forEach(e => visualizerApi.addListener(e, () => this.props.notifyEvent('Logs', e)))
    } else if (state === IframeLoadingState.UNMOUNTING) {
      logsIframeEvents.forEach(e => visualizerApi.removeListener(e))
    }
  }
}
